<template>
  <!--
    	作者：wangxw
    	时间：2019-10-26
    	描述：菜品分类-修改
    -->
  <el-dialog :title="$t('修改分类')" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
    :close-on-press-escape="false">
      <!--多语言-->
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane v-for="tab in translations" :key="tab.text" :label="tab.text" :name="tab.name">
        <span slot="label">{{tab.text}}<i v-if="tab.translated" class="el-icon-success" style="color: #67C23A"></i></span>
      </el-tab-pane>
    </el-tabs>
    <el-form size="small" :model="form" :rules="formRules" ref="form">
      <el-form-item :label="$t('分类名称')" prop="name" :label-width="formLabelWidth">
        <el-input v-model="form.name" autocomplete="off" style="width: 60%"></el-input>

        <mi-free-time :styles="{left:'60px',top:'5px'}">
          <el-button size="small" type="warning" @click="translateLanguage()" :loading="translateLoading">{{$t('翻译')}}</el-button>
        </mi-free-time>
      </el-form-item>
      <el-form-item :label="$t('分类图片')" prop="image_id" :label-width="formLabelWidth">
        <el-row>
          <el-button type="primary" @click="openUpload">{{$t('选择图片')}}</el-button>
          <div v-if="form.image_id!=''" class="img">
            <img :src="file_path" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>
      <el-form-item :label="$t('分类排序')" prop="sort" :label-width="formLabelWidth">
        <el-input v-model.number="form.sort" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">{{$t('取 消')}}</el-button>
      <el-button type="primary" @click="addUser" :loading="loading">{{$t('确 定')}}</el-button>
    </div>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" :isAspectRatio="false" @returnImgs="returnImgsFunc">{{$t('上传图片')}}</Upload>
  </el-dialog>
</template>

<script>
  import PorductApi from '@/api/product.js';
  import Upload from '@/components/file/Upload';
  export default {
    components: {
      Upload
    },
    data() {
      return {
        translations: {
        chinese: { text: this.$t('中文'), translated: false, name: 'chinese', categoryName: "" },
        english: { text: this.$t('英语'), translated: false, name: 'english', categoryName: "" },
        italian: { text: this.$t('意大利语'), translated: false, name: 'italian', categoryName: "" },
        german: { text: this.$t('德语'), translated: false, name: 'german', categoryName: "" },
        spanish: { text: this.$t('西班牙语'), translated: false, name: 'spanish', categoryName: "" },
        french: { text: this.$t('法语'), translated: false, name: 'french', categoryName: "" },
        croatia: { text: this.$t('克罗地亚'), translated: false, name: 'croatia', categoryName: "" },
        slovenia: { text: this.$t('斯洛文尼亚'), translated: false, name: 'slovenia', categoryName: "" },
        hungarian: { text: this.$t('匈牙利语'), translated: false, name: 'hungarian', categoryName: "" },
        },
        translateLoading:false,
        activeName:'chinese',
        form: {
          category_id: 0,
          parent_id: 0,
          name: '',
          image_id: '',
          sort: ''
        },
        file_path: '',
        formRules: {
          name: [{
            required: true,
             message: this.$t('请输入分类名称'),
            trigger: 'blur'
          }],
          image_id: [{
            required: true,
            message: '请上传分类图片',
            trigger: 'blur'
          }],
          sort: [{
            required: true,
            message: this.$t('分类排序不能为空')
          }, {
            type: 'number',
            message: this.$t('分类排序必须为数字')
          }]
        },
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,
        loading: false,
        /*是否上传图片*/
        isupload: false,
      };
    },
    props: ['open_edit', 'editform'],
    created() {
      this.dialogVisible = this.open_edit;
      this.form.category_id = this.editform.model.category_id;
      this.form.parent_id = this.editform.model.parent_id;
      this.form.name = this.editform.model.name;
      console.log(this.editform.model.name)
      this.form.sort = this.editform.model.sort;
      this.form.image_id = this.editform.model.image_id;
      let parsedJson;
      if(this.editform.model.lang && this.editform.model.lang.category){
        parsedJson = JSON.parse(this.editform.model.lang.category)
      }
      if(parsedJson != null || parsedJson != undefined){
        for (const key in parsedJson) {
          if (key in this.translations) {
            this.translations[key].categoryName = parsedJson[key];
          }
        }
      }
      if(this.editform.model.images && this.editform.model.images.file_path){
        this.file_path = this.editform.model.images.file_path;
      }
    },
    mounted() {
      // 监听 form 对象中的任何一个属性的变化
      this.$watch('form', (newForm, oldForm) => {
          // 处理 form 对象变化的逻辑
          console.log(this.form.name)
          this.$set(this.translations[this.activeName],'categoryName',this.form.name)
        }, { deep: true });
      },
    methods: {
      /*标签页切换*/
      handleClick(tab, event) {
        // 切换表单数据为对应的语言数据
        const translation = this.translations[tab.name];
        if (translation.categoryName && typeof translation.categoryName === 'string') {
          this.form.name = translation.categoryName;
        }
      },
      translateLanguage: function(){
        let self = this
        let word = self.form.name;
        Object.keys(this.translations).forEach((language) => {
          if(language != "chinese"){
            this.requestServerTranslate(word,language)
          }
        });
      },
      requestServerTranslate(word,language){
        this.translations.chinese.categoryName = word
        let translateData = {
          "word": word,
          "language": language
        }
        this.translateLoading = true
        PorductApi.translate_word(translateData, true).then(res => {
          this.translateLoading = false
          if(res.code == 1){
            let translatedRes = res.data.response
            //拿到大模型返回的翻译数据
            this.translations[language].categoryName = translatedRes
            this.translations[language].translated = true
          }
        }).catch(error => {
          this.translateLoading = false
          console.log("翻译出错了")
        });
      },
      /*修改用户*/
      addUser() {
        let self = this;
        let params = this.form;
        params.name = this.translations.chinese.categoryName
        params.category_lang = JSON.stringify({
          "chinese":this.translations.chinese.categoryName,
          "english":this.translations.english.categoryName,
          "italian":this.translations.italian.categoryName,
          "german":this.translations.german.categoryName,
          "spanish":this.translations.spanish.categoryName,
          "french":this.translations.french.categoryName,
          "croatia":this.translations.croatia.categoryName,
          "slovenia":this.translations.slovenia.categoryName,
          "hungarian":this.translations.hungarian.categoryName,
        })
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            PorductApi.storeCatEdit(params, true).then(data => {
              self.loading = false;
              self.$message({
               message: self.$t('修改成功'),
                type: 'success'
              });
              self.dialogFormVisible(true);
            }).catch(error => {
              self.loading = false;
            });
          }
        });
      },
      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },
      /*上传*/
      openUpload(e) {
        this.type = e;
        this.isupload = true;
      },
      /*获取图片*/
      returnImgsFunc(e) {
        if (e != null && e.length > 0) {
          this.file_path = e[0].file_path;
          this.form.image_id = e[0].file_id;
        }
        this.isupload = false;
      },

    }
  };
</script>

<style>
  .img {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/product/store/category/Edit.vue